export enum StatusCorIndicadorAlerta {
    AO_INCLUIR = "9bca9c",
    PEDENTE_POSTO ="ff6c60",
	PENDENTE_VALIDACAO="f8d249",
	FECHADO="7fccff"
}